import React from "react";
import feedback_logo from "../../assets/images/feedback_logo.png";
import "./index.less";
import Zendesk from "react-zendesk";
const ZENDESK_KEY = "e538a342-0989-45aa-838d-dd37695280cd";
const setting = {};
const Feedback = () => {
  const handleFeedback = () => {
    window.open("https://rvcp2u85rs.jiandaoyun.com/f/61e67cbe28ea550007e2b079");
  };
  return (
    <>
      <Zendesk
        defer
        zendeskKey={ZENDESK_KEY}
        {...setting}
        onLoaded={() => console.log("is loaded")}
      />
      <div className="feedback" onClick={handleFeedback}>
        <div className="feedback_content">
          <img src={feedback_logo} alt="fr_feedback_logo" />
          <p>視&nbsp;頻回&nbsp;饋</p>
        </div>
        <div className="feedback_cover"></div>
      </div>
    </>
  );
};

export default Feedback;
